import { defineMessages } from 'react-intl';

export default defineMessages({
  feedBackSuccessMessage: {
    id: 'feedBackSuccessMessage',
    defaultMessage: 'You’ve successfully submitted feedback',
  },
});
